const cartCountUpdate = async () => {
  const countEls = document.querySelectorAll(".header__wrapper .count-bubble");
  const res = await fetch("/cart.js");
  const data = await res.json();
  let count = 0;
  data.items.forEach(item => {
    if (item.properties) {
      const isMainBundle = item.properties._bundle_ids;

      if (isMainBundle) {
        count += item.quantity;
      } else {
        const hasBundleType = item.properties._bundle_type;

        if (!hasBundleType) {
          count += item.quantity;
        }
      }
    } else {
      count += item.quantity;
    }
  });

  countEls.forEach(countEl => countEl.innerText = count)
}

document.addEventListener("cart:refresh", cartCountUpdate)
document.addEventListener("cart:change", cartCountUpdate)